import { render, staticRenderFns } from "./CaregiverMatchedCalendar.vue?vue&type=template&id=8c5ba7ac&scoped=true"
import script from "./CaregiverMatchedCalendar.vue?vue&type=script&lang=js"
export * from "./CaregiverMatchedCalendar.vue?vue&type=script&lang=js"
import style0 from "./CaregiverMatchedCalendar.vue?vue&type=style&index=0&id=8c5ba7ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5ba7ac",
  null
  
)

export default component.exports